<template>
  <div id="big-screen-main">
    <div class="big-screen-bg">
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="big-screen-body">
        <!--        线条标题-->
        <div class="d-flex jc-center">
          <dv-decoration-10 class="dv-dec-10" />
          <div class="d-flex jc-center">
            <dv-decoration-8 class="dv-dec-8" :color="decorationColor" />
            <div class="title">
              <span class="title-text">车辆排队叫号</span>
              <dv-decoration-6 class="dv-dec-6" :reverse="true" :color="['#50e3c2', '#67a1e5']" />
            </div>
            <dv-decoration-8 class="dv-dec-8" :reverse="true" :color="decorationColor" />
          </div>
          <dv-decoration-10 class="dv-dec-10-s" />
        </div>
        <!--        时间-->
        <div class="d-flex jc-between px-2">
          <div class="d-flex aside-width">
            <div class="square-left ml-4 square-l-s">
              <span class="square-left" />
              <span class="text" />
            </div>
            <div class="square-left ml-3">
              <span class="text" />
            </div>
          </div>
          <div class="d-flex aside-width">
            <div class="square-right mr-3 square-r-s">
              <span class="text" />
            </div>
            <div class="square-right mr-4 square-l-s">
              <span class="square-after" />
              <span class="text">{{ timeNow }}</span>
            </div>
          </div>
        </div>
        <div class="screen-main" id="screen-main">
          <div class="screen-container">
            <div class="left-part">
              <div class="part-title">等待调度({{ leftCount }})</div>
              <div class="left-part-table">
                <el-table ref="leftTable" :data="leftTableData" size="small" style="width: 100%;" :height="tableHeight">
                  <el-table-column label="车牌" prop="vehicleNumber" align="center"
                    show-overflow-tooltip></el-table-column>
                  <el-table-column label="司机" prop="driverName" align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column label="作业类型" prop="operateTypeName" align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column label="签到时间" prop="checkInTime" align="center" width="260" show-overflow-tooltip></el-table-column>
                </el-table>
              </div>
            </div>
            <div class="right-part">
              <div class="part-title">排队叫号({{ rightCount }})</div>
              <div class="right-part-table">
                <el-table ref="rightTable" :data="rightTableData" size="small" style="width: 100%;" :height="tableHeight">
                  <el-table-column label="车牌" prop="vehicleNumber" align="center"
                    show-overflow-tooltip></el-table-column>
                  <el-table-column label="司机" prop="driverName" align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column label="冷库" prop="storageName" align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column label="月台" prop="platformCode" align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column label="月台排号" prop="order" align="center" show-overflow-tooltip></el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      decorationColor: ['#568aea', 'transparent'],
      // 时间
      timer: null,
      timeNow: '',
      weekday: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      leftTableData: [],
      leftCount: 0,
      rightTableData: [],
      rightCount: 0,
      tableHeight: "auto",
      requestTimer: null,
      scrollTimer: null
    }
  },
  mounted() {
    const self = this
    if (this.timer) {
      clearInterval(this.timer)
    }
    this.timer = setInterval(self.getNowTime, 1000)
    this.cancelLoading()
    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer)
    }
    this.scrollTimer = setTimeout(() => {
      this.initScroll()
      this.initScrollRight()
    }, 1000)
    window.onresize = () => {
      this.getTableHeight()
    }
    this.getLeftList()
    this.getRightList()
    if (this.requestTimer) {
      clearInterval(this.requestTimer)
    }
    // this.requestTimer = setInterval(self.getList, 5000)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
    if (this.requestTimer) {
      clearInterval(this.requestTimer)
    }
  },
  methods: {
    cancelLoading() {
      setTimeout(() => {
        this.loading = false
        this.getTableHeight()
      }, 1000)
    },
    getNowTime() {
      const nowTime = new Date()
      const y = nowTime.getFullYear()
      let M = nowTime.getMonth() + 1
      M = M < 10 ? '0' + M : M
      let d = nowTime.getDate()
      d = d < 10 ? '0' + d : d
      let h = nowTime.getHours()
      h = h < 10 ? '0' + h : h
      let m = nowTime.getMinutes()
      m = m < 10 ? '0' + m : m
      let s = nowTime.getSeconds()
      s = s < 10 ? '0' + s : s
      const w = nowTime.getDay()
      const currentDate = y + '/' + M + '/' + d
      const currentTime = h + ':' + m + ':' + s
      const currentWeek = this.weekday[w]
      this.timeNow = currentDate + ' ' + currentTime + ' ' + currentWeek
    },
    getTimeStr(time) {
      if (time) {
        const nowTime = new Date(time)
        const y = nowTime.getFullYear()
        let M = nowTime.getMonth() + 1
        M = M < 10 ? '0' + M : M
        let d = nowTime.getDate()
        d = d < 10 ? '0' + d : d
        let h = nowTime.getHours()
        h = h < 10 ? '0' + h : h
        let m = nowTime.getMinutes()
        m = m < 10 ? '0' + m : m
        let s = nowTime.getSeconds()
        s = s < 10 ? '0' + s : s
        const currentDate = y + '/' + M + '/' + d
        const currentTime = h + ':' + m + ':' + s
        return currentDate + ' ' + currentTime
      }
    },
    getTableHeight() {
      const screenMain = document.getElementById("screen-main")
      this.tableHeight = screenMain.clientHeight - 110 + "px"
    },
    initScroll() {
      const table = this.$refs.leftTable
      // 获取表格中承载数据的div
      const divData = table.bodyWrapper
      // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每1秒移动20像素)
      let timer;
      function start() {
        // 数据少于表格高度停止滚动
        if (divData.clientHeight >= divData.scrollHeight) {
          return;
        }
        timer = setInterval(() => {
          // 元素自增距离顶部1像素
          divData.scrollTop += 50;
          // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
          if (divData.clientHeight + divData.scrollTop == divData.scrollHeight) {
            // 重置table距离顶部距离
            divData.scrollTop = 0
          }
        }, 1000)
      }
      start()
      // 鼠标移入 停止滚动
      divData.onmouseover = function () {
        clearInterval(timer)
      }
      // 鼠标移出，继续滚动
      divData.onmouseout = function () {
        start()
      }
    },
    initScrollRight() {
      const table = this.$refs.rightTable
      // 获取表格中承载数据的div
      const divData = table.bodyWrapper
      // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每1秒移动20像素)
      let timer;
      function start() {
        // 数据少于表格高度停止滚动
        if (divData.clientHeight >= divData.scrollHeight) {
          return;
        }
        timer = setInterval(() => {
          // 元素自增距离顶部1像素
          divData.scrollTop += 50;
          // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
          if (divData.clientHeight + divData.scrollTop == divData.scrollHeight) {
            // 重置table距离顶部距离
            divData.scrollTop = 0
          }
        }, 3000)
      }
      start()
      // 鼠标移入 停止滚动
      divData.onmouseover = function () {
        clearInterval(timer)
      }
      // 鼠标移出，继续滚动
      divData.onmouseout = function () {
        start()
      }
    },
    getList() {
      this.getLeftList()
      this.getRightList()
    },
    getLeftList() {
      this.$fetch('/dep/queryRailwayPlatformVehicle/waitingDistributed', {}).then((response) => {
        if (response.success) {
          this.leftTableData = response.returnObj
          this.leftCount = response.returnObj.length
          this.leftTableData.push({})
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    getRightList() {
      this.$fetch('/dep/queryRailwayPlatformVehicle/waitingQueue', {}).then((response) => {
        if (response.success) {
          this.rightTableData = response.returnObj
          this.rightCount = response.returnObj.length
          this.rightTableData.push({})
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
  }
}
</script>
<style>
.screen-main .el-table {
  background-color: #181f2e !important;
  color: #e2e1e4 !important;
}

.screen-main .el-table thead th {
  background-color: #343D55 !important;
  color: #ffffff !important;
  font-size: 22px !important;
}

.screen-main .el-table tbody tr {
  background-color: #181f2e !important;

  &:nth-child(even) {
    background-color: #242B3D !important;
  }
}

.screen-main .el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #343D55 !important;
}

.screen-main .el-table__body-wrapper {
  background-color: #181f2e !important;
}
</style>

<style lang="scss" scoped>
#big-screen-main {
  color: #d3d6dd;
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transform-origin: left top;
  overflow: hidden;

  .big-screen-bg {
    width: 100%;
    height: 100%;
    padding: 16px 16px 0 16px;
    background-image: url("../../assets/images/screen/pageBg.png");
    background-size: cover;
    background-position: center center;
  }

  .big-screen-body {

    .dv-dec-10,
    .dv-dec-10-s {
      width: 33.3%;
      height: 5px;
    }

    .dv-dec-10-s {
      transform: rotateY(180deg);
    }

    .dv-dec-8 {
      width: 200px;
      height: 50px;
    }

    .title {
      position: relative;
      width: 500px;
      text-align: center;
      background-size: cover;
      background-repeat: no-repeat;

      .title-text {
        font-size: 34px;
        letter-spacing: 6px;
        font-weight: 600;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%);
        // color: #F2F6FC;
        background-image: linear-gradient(to top, #4481eb 0%, #04befe 100%);
        color: transparent;
        background-clip: text;
        -webkit-background-clip: text;
        height: 60px;
        line-height: 80px;
      }

      .dv-dec-6 {
        position: absolute;
        bottom: -30px;
        left: 50%;
        width: 250px;
        height: 8px;
        transform: translate(-50%);
      }
    }

    .aside-width {
      width: 40%;
    }

    .square-r-s,
    .square-l-s {
      background-color: #0f1325;
    }

    .square-right {
      &.square-l-s {
        text-align: right;
        width: 500px;
      }

      font-size: 18px;
      width: 300px;
      line-height: 50px;
      text-align: center;
      transform: skewX(-45deg);

      .square-after {
        position: absolute;
        right: -25px;
        top: 0;
        height: 50px;
        width: 50px;
        background-color: #0f1325;
        transform: skewX(45deg);
      }

      .text {
        display: inline-block;
        transform: skewX(45deg);
        color: #ffffff;
      }
    }

    .square-left {
      &.square-l-s {
        width: 500px;
        text-align: left;
      }

      font-size: 18px;
      width: 300px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      transform: skewX(45deg);
      background-color: #0f1325;

      .square-left {
        position: absolute;
        left: -25px;
        top: 0;
        height: 50px;
        width: 50px;
        background-color: #0f1325;
        transform: skewX(-45deg);
      }

      .text {
        display: inline-block;
        transform: skewX(-45deg);
      }
    }

    .screen-main {
      width: 100%;
      height: 100%;
      padding: 10px;
      overflow-y: hidden;

      .screen-container {
        display: flex;
        width: 100%;
        height: calc(100vh - 130px);

        .left-part {
          width: 50%;
          border-right: 1px solid #606266;

          .left-part-table {
            margin: 10px 10px 20px 0;
          }
        }

        .right-part {
          width: 50%;

          .right-part-table {
            margin: 10px 0 20px 10px;
          }
        }

        .part-title {
          font-size: 32px;
          // color: #ffffff;
          font-weight: 600;
          background-image: linear-gradient(to top, #4481eb 30%, #04befe 80%);
          color: transparent;
          background-clip: text;
          -webkit-background-clip: text;
          width: 100%;
          height: 70px;
          line-height: 70px;
          text-align: center;
          border-top: 1px solid #606266;
          border-bottom: 1px solid #606266;
        }
      }
    }
  }

  ::-webkit-scrollbar-thumb {
    background-color: transparent !important;
  }
}

.screen-main .el-table--small,
.screen-main .el-table__expand-icon {
  font-size: 23px;
}

::v-deep(.el-table__header) {
  tr {
    height: 50px;
    line-height: 50px;
    letter-spacing: 5px;
  }
}

::v-deep(.el-table__body) {
  tr {
    .cell {
      height: 50px;
      line-height: 50px;
    }
  }
}

.d-flex {
  display: flex;
}

.jc-center {
  justify-content: center;
}

.jc-between {
  justify-content: space-between;
}

.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.ml-4 {
  margin-left: 1rem;
}

.ml-3 {
  margin-left: 0.75rem
}

.mr-4 {
  margin-right: 1rem;
}

.mr-3 {
  margin-right: 0.75rem
}
</style>

